import React from 'react';

// Line icons from the client redesign (roam4less-redesign/src/icons.js).
const Svg = ({ children }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    {children}
  </svg>
);

export const CartIcon = () => (
  <Svg>
    <path d="M6 6h15l-1.5 9h-12z" />
    <path d="M6 6 5 3H2" />
    <circle cx="9" cy="20" r="1.3" fill="currentColor" stroke="none" />
    <circle cx="18" cy="20" r="1.3" fill="currentColor" stroke="none" />
  </Svg>
);

export const GlobeIcon = () => (
  <Svg>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c2.5 2.8 3.8 5.8 3.8 9S14.5 18.2 12 21c-2.5-2.8-3.8-5.8-3.8-9S9.5 5.8 12 3z" />
  </Svg>
);

export const MenuIcon = () => (
  <Svg>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Svg>
);

export const CloseIcon = () => (
  <Svg>
    <path d="M6 6l12 12M18 6 6 18" />
  </Svg>
);

export const PinIcon = () => (
  <Svg>
    <path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z" />
    <circle cx="12" cy="10" r="2.2" />
  </Svg>
);

export const SearchIcon = () => (
  <Svg>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </Svg>
);

export const PhoneIcon = () => (
  <Svg>
    <rect x="7" y="2" width="10" height="20" rx="2" />
    <path d="M11 18h2" />
  </Svg>
);

export const StarIcon = () => (
  <Svg>
    <path d="m12 3 2.5 6H21l-5 4 2 7-6-4-6 4 2-7-5-4h6.5z" />
  </Svg>
);

export const InfinityIcon = () => (
  <Svg>
    <path d="M8 16c2-6 6-10 14-14-4 8-8 12-14 14z" />
    <path d="M10 14c-4 1-7 4-8 8 4-1 7-4 8-8z" />
  </Svg>
);

export const UnlimitedIcon = () => (
  <Svg>
    <path d="M6.5 7.5a4.5 4.5 0 1 0 0 9c2.6 0 4-2.2 5.5-4.5s2.9-4.5 5.5-4.5a4.5 4.5 0 1 1 0 9c-2.6 0-4-2.2-5.5-4.5S9.1 7.5 6.5 7.5z" />
  </Svg>
);

export const DataStackIcon = () => (
  <Svg>
    <ellipse cx="12" cy="6" rx="7" ry="3" />
    <path d="M5 6v12c0 1.7 3.1 3 7 3s7-1.3 7-3V6" />
    <path d="M5 12c0 1.7 3.1 3 7 3s7-1.3 7-3" />
  </Svg>
);

export const SignalIcon = () => (
  <Svg>
    <path d="M4 18V9M9 18V6M14 18v-7M19 18V4" />
  </Svg>
);

export const CheckIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true">
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const QrIcon = () => (
  <Svg>
    <rect x="7" y="2" width="10" height="20" rx="2" />
    <path d="M9 7h6M9 11h6" />
  </Svg>
);

export const WifiIcon = () => (
  <Svg>
    <path d="M5 13a7 7 0 0 1 14 0" />
    <path d="M8.5 13a3.5 3.5 0 0 1 7 0" />
    <circle cx="12" cy="17" r="1" fill="currentColor" stroke="none" />
  </Svg>
);

export const TrashIcon = () => (
  <Svg>
    <path d="M4 7h16M10 11v6M14 11v6" />
    <path d="M6 7l1 13h10l1-13M9 7V4h6v3" />
  </Svg>
);

export const BoltIcon = () => (
  <Svg>
    <path d="M13 2 4 14h7l-1 8 9-12h-7z" />
  </Svg>
);

export const ShieldIcon = () => (
  <Svg>
    <path d="M12 3 5 6v6c0 4.5 3 7.5 7 9 4-1.5 7-4.5 7-9V6z" />
  </Svg>
);

export const HeadsetIcon = () => (
  <Svg>
    <path d="M4 14a8 8 0 0 1 16 0" />
    <path d="M4 14v2a2 2 0 0 0 2 2h1v-5M20 14v2a2 2 0 0 1-2 2h-1v-5" />
  </Svg>
);

export const PlaneIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true">
    <path d="M3 13.2 20 4l-2.4 8.2L21 19l-8.6-3.5L9.2 21l.7-6.6z" />
  </svg>
);
